import type { LegacyChoiceResult } from '@core-api/presentation/types/response';
import { useFetchChoiceResults } from '@mentimeter/presentation-data-hooks/fetch-choice-results';

interface UseChoiceResultsParams {
  adminKey: string;
  shouldFetchResults: boolean;
  sessionId: number | undefined;
  segmentBy?: string | undefined;
}

export const useChoiceResults = ({
  adminKey,
  shouldFetchResults,
  sessionId,
}: UseChoiceResultsParams): {
  identifiedResults: LegacyChoiceResult[] | null;
  isLoading: boolean;
} => {
  const { data, isLoading } = useFetchChoiceResults({
    adminKey,
    shouldFetchResults,
    sessionId,
  });

  return {
    identifiedResults: data?.results ?? null,
    isLoading,
  };
};
